<template lang="pug">
  game-preview-settings
    game-preview-setting
      span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_game') }}
      span(slot="value") {{ $i18n.t('common.common_gameName_sequenceOfNumbers') }}
    game-preview-setting
      span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_sequenceOfNumbersMode') }}
      span(slot="value") {{ gameMode }}
    game-preview-setting
      span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_tableSize') }}
      span(slot="value") {{ tableSize }}
    game-preview-setting(v-if="!parameters.countingCombinations")
      span(slot="name") {{ titleForNumOfExamples }}
      span(slot="value") {{ parameters.numOfExamples }}
    game-preview-setting
      span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_location') }}
      span(slot="value")
        div(v-if="parameters.location.vertically") {{ $i18n.t('trainer.trainer_gameFormSetting_location-vertically') }}
        div(v-if="parameters.location.horizontally") {{ $i18n.t('trainer.trainer_gameFormSetting_location-horizontally') }}
        div(v-if="parameters.location.diagonally") {{$i18n.t('trainer.trainer_gameFormSetting_location-diagonally') }}
    game-preview-setting
      span(slot="name") {{ titleForCrossingSettings }}
      span(slot="value") {{ checkIsSettingsOn(parameters.crossing) }}
    game-preview-setting
      span(slot="name") {{ titleForDigitCapacitySettings }}
      span(slot="value") {{ digitCapacityMode }}
    game-preview-setting(v-if="!checkIsNumberGameMode")
      span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_counting-combinations') }}
      span(slot="value") {{ checkIsSettingsOn(parameters.countingCombinations) }}
    game-preview-setting
      span(slot="name") {{ titleForIsColoredSettings }}
      span(slot="value") {{ checkIsSettingsOn(parameters.coloredNumbers) }}
</template>

<script>
    import GamePreviewSettings from './GamePreviewSettings.vue';
    import GamePreviewSetting from './GamePreviewSetting.vue';
    import GamePreviewMixin from '../../../utils/trainer/gamePreviewMixin';
    import SequenceOfNumbersConfig from '../configs/SequenceOfNumbersConfig';

    const NUMBERS_GAME_MODE = 'numbers';

    export default {
        data() {
            return {
                digitCapacityModes: SequenceOfNumbersConfig.getDigitCapacityModes(),
            };
        },
        props: {
            parameters: Object,
            exerciseId: [Number, String],
            type: String,
        },
        mixins: [GamePreviewMixin],
        components: {
            GamePreviewSettings,
            GamePreviewSetting,
        },
        methods: {
            checkIsSettingsOn(settingValue) {
                return settingValue
                    ? this.$i18n.t('trainer.trainer_gameFormSettingValue_on')
                    : this.$i18n.t('trainer.trainer_gameFormSettingValue_off');
            },
        },
        computed: {
            digitCapacityMode() {
                return this.digitCapacityModesWithLabel.find(mode => mode.value === +this.parameters.digitCapacity)
                    .label;
            },
            gameMode() {
                return this.checkIsNumberGameMode
                    ? this.$i18n.t('trainer.trainer_gameFormSetting_sequenceOfNumbersModeNumbers')
                    : this.$i18n.t('trainer.trainer_gameFormSetting_sequenceOfNumbersModeCharacters');
            },
            tableSize() {
                return this.parameters.tableSize + ' x ' + this.parameters.tableSize;
            },
            titleForNumOfExamples() {
                return this.checkIsNumberGameMode
                    ? this.$i18n.t('trainer.trainer_gameFormSetting_amountOfNumbers')
                    : this.$i18n.t('trainer.trainer_gameFormSetting_amountOfCombination');
            },
            titleForDigitCapacitySettings() {
                return this.checkIsNumberGameMode
                    ? this.$i18n.t('trainer.trainer_gameFormSetting_difficulty')
                    : this.$i18n.t('trainer.trainer_gameFormSetting_numOfCharacters');
            },
            titleForCrossingSettings() {
                return this.checkIsNumberGameMode
                    ? this.$i18n.t('trainer.trainer_gameFormSetting_crossing-numbers')
                    : this.$i18n.t('trainer.trainer_gameFormSetting_crossing-characters');
            },
            titleForIsColoredSettings() {
                return this.checkIsNumberGameMode
                    ? this.$i18n.t('trainer.trainer_gameFormSetting_coloredNumbers')
                    : this.$i18n.t('trainer.trainer_gameFormSetting_coloredCharacters');
            },
            checkIsNumberGameMode() {
                return this.parameters.mode === NUMBERS_GAME_MODE;
            },
            digitCapacityModesWithLabel() {
                return this.digitCapacityModes.map(mode => {
                    mode.label = this.checkIsNumberGameMode ? mode.labelForNumbersMode : mode.labelForCharactersMode;
                    return mode;
                });
            },
        },
    };
</script>
